import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  profile: {},
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfile: (state, action: PayloadAction<any>) => {
      state.profile = action.payload;
    },
    updateProfileFields: (
      state,
      action: PayloadAction<Partial<typeof initialState.profile>>
    ) => {
      state.profile = {
        ...state.profile,
        ...action.payload,
      };
    },
  },
});

export const { setProfile, updateProfileFields } = profileSlice.actions;

export default profileSlice.reducer;

